import Vue from 'vue'
import Router from 'vue-router'
import RecoverPassword from "@/views/RecoverPassword";
import ChangePassword from "@/views/ChangePassword";
import PasswordChanged from "@/views/PasswordChanged";
import Register from "@/views/Register";
import RegistrationSuccess from "@/views/RegistrationSuccess";
import RecoverPasswordSuccess from "@/views/RecoverPasswordSuccess";

window._ = require('lodash');

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            component: Register
        },        {
            path: '/signup',
            component: Register
        },
        {
            path: '/signup-success',
            component: RegistrationSuccess,
            props: {title: 'Registrazione completata', message: 'Puoi accedere utilizzando le credenziali inserite', width: '550px'}
        },
        {
            path: '/recover-password',
            component: RecoverPassword
        },
        {
            path: '/change-password/:token',
            component: ChangePassword,
            props: {type: 'change'}
        },
        {
            path: '/recover-password-success',
            component: RecoverPasswordSuccess,
            props: {title: 'Richiesta inviata', message: 'Se hai fornito uno username corretto o un indirizzo email corretto, riceverai una email.<br><br>Nel messaggio troverai le istruzioni per confermare e completare la modifica della password. Se continui ad avere difficoltà, contatta l\'amministratore del sito.', width: '550px'}
        },
        {
            path: '/password-changed',
            component: PasswordChanged,
            props: {title: 'Password modificata.', message: 'Puoi accedere utilizzando le credenziali inserite', width: '550px'}
        }
    ]
})
